import './Shop.css'
import React, { useState } from 'react'
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import GoogleMap from 'google-map-react'
import { decode } from 'html-entities'
import MarkerIcon from './images/marker_new.svg'

const GoogleMapMarker = ({ text }) => <div style={{ height: '47px', width: '40px', overflow: 'hidden' }}>
  <img src={MarkerIcon} style={{ height: '100%', width: '100%' }}/>
</div>

function Shop (props) {
  const [direction, setDirection] = useState('map')

  return (
    <AccordionItem className={`shop ${props.className || ''}`} activeClassName={'shop expanded'}>
      <AccordionItemHeading>
        <AccordionItemButton className='accordion__button bg-[#f3f3f3] relative cursor-pointer flex items-center text-[14px] px-[34px] pt-[25px] pb-[15px] pl-[25px] mt-[20px] min-h-[108px] rounded-[14px]'>
          <div className="accordeon_head-row">
            <div className="accordeon_head-col">
              <span className="addr">{decode(props.name)}</span>
            </div>
            <div className="accordeon_head-col">
              {
                props.address.length ?
                  <span>{decode(props.address)}</span> :
                  <></>
              }
              {
                props.subway.length ?
                  <span>{decode(props.subway)}</span> :
                  <></>
              }
            </div>

            <div className="accordeon_head-col">
              {
                props.phone.length ?
                  <span>{decode(props.phone)}</span> :
                  <></>
              }
            </div>

            <div className="accordeon_head-col">
              <span>{props.getMessage('CT_BNL_SM_MON_FRI')}: {props.weekdays_worktime}</span>
              <span>{props.getMessage('CT_BNL_SM_SAT_SUN')}: {props.weekend_worktime}</span>
            </div>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel className='bg-[#f3f3f3] px-[10px] pb-[35px] text-[13px] rounded-b-[14px]'>
        <div className="flex bg-white pt-[30px] px-[30px] pb-[20px] phone:flex-wrap phone:gap-[20px]">
          <div className="w-[290px] mr-[30px] phone:w-full">
            {
              props.description.length ?
                <span className="inline-block w-full mb-[30px] leading-[1.6]">{decode(props.description)}</span> :
                <></>
            }
            <div>
              <a href="#" className={`inline-block mr-[25px] mb-[15px] text-[#6364ff] ${direction === 'map' ? 'border-[#6364ff] text-[#333333]' : ''}`}
                 onClick={e => {
                   e.preventDefault()
                   setDirection('map')
                 }}>
                {props.getMessage('CT_BNL_SM_MAP_LINK')}
              </a>
              {
                props.hasOwnProperty('photos') && Array.isArray(props.photos) && props.photos.length ?
                  <a href="#" className={`inline-block mr-[25px] mb-[15px] text-[#6364ff] ${direction === 'way' ? 'border-[#6364ff] text-[#333333]' : ''}`}
                     onClick={e => {
                       e.preventDefault()
                       setDirection('way')
                     }}>
                    {props.getMessage('CT_BNL_SM_SLIDER_LINK')}
                  </a> :
                  <></>
              }
            </div>
            <a href={props.googleLink} target="_blank">{props.getMessage('CT_BNL_SM_GOOGLE_MAP_LINK')}</a>
          </div>
          <div className="w-[calc(100%-320px)] relative min-h-[340px] mb-[10px] phone:w-full">
            {
              direction === 'map' && parseFloat(props.lat) > 0 && parseFloat(props.lng) > 0 ?
                  <GoogleMap bootstrapURLKeys={{
                    key: 'AIzaSyBh5pjyr7g-9WKLbdZBPcrT3H6V3FEGj_Q',
                    language: props.lang,
                    region: 'ua'
                  }}
                             defaultCenter={{ lat: props.lat, lng: props.lng }}
                             defaultZoom={16}>
                    <GoogleMapMarker
                      lat={props.lat}
                      lng={props.lng}
                      text="welcome to the tehnoezh.ua"/>
                  </GoogleMap> :
                  <></>
            }
            {
              direction === 'way' && props.hasOwnProperty('photos') && Array.isArray(props.photos) && props.photos.length ?
                <picture>
                  <source srcSet={props.photos[0].CONVERTED_SRC} type="image/webp"/>
                  <img src={props.photos[0].SRC} alt={decode(props.name)}/>
                </picture> :
                <></>
            }
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  )
}

export default Shop